// component
import AuditApplyListCom from './audit-apply-list/audit-apply-list.vue';
import AuditApplyDetailCom from './audit-apply-detail/audit-apply-detail.vue';

export default [
  {
    path: 'list',
    name: 'auditApplyList',
    component: AuditApplyListCom,
    meta: {
      title: '报名审核',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'detail',
    name: 'auditApplyDetail',
    component: AuditApplyDetailCom,
    meta: {
      title: '审核报名',
      breadCrumbShowIndexArr: [0, 2, 3, 4]
    }
  }
];

